<div class="card-body">
    <div id="apex-mixed-multiple-y-axis-charts"></div>
</div>